import { Box, Button } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useApiMutation } from "src/hooks/useApiMutation";
import { useApiQuery } from "src/hooks/useApiQuery";
import type { ICreateAccount } from "src/Types/account.types";
import MoneyReceiptForm from "./MoneyReceiptForm";
import type { ISingleMoneyReceipt } from "./type/moneyReceiptType";

interface IProps {
	handleClose: () => void;
	id: number;
}
const EditMoneyReceipt = ({ handleClose, id }: IProps) => {
	const { data: moneyRece, isLoading } = useApiQuery<ISingleMoneyReceipt>({
		endPoint: `/api/admin/exhibitor/money-receipt/${id}`,
		queryKeys: ["money-receipt", id],
	});
	const { mutate: createAccount, isPending } = useApiMutation<
		ICreateAccount,
		void
	>({
		method: "POST",
		endPoint: "/api/fair/admin/account",
		invalidateQueries: ["Accounts"],
	});

	const onSubmit = (formData: ICreateAccount) => {
		console.log(formData);
		//createAccount(formData);
		// handleClose();
		//reset();
	};

	const { control, register, handleSubmit, reset, formState, watch } =
		useForm<any>({
			...(true && {
				defaultValues: {
					amount: 9999,
					payment_method: "Bank",
					exhibitor_id: 69,
				},
			}),
		});

	useEffect(() => {
		if (moneyRece) {
			reset({ ...moneyRece, exhibitor_id: 69 });
		}
	}, [moneyRece]);
	return (
		<Box
			component='form'
			onSubmit={handleSubmit(onSubmit)}
			sx={{ p: 2, mt: 1 }}
		>
			<MoneyReceiptForm
				register={register}
				watch={watch}
				control={control}
			/>

			<Button
				type='submit'
				fullWidth
				variant='contained'
				sx={{ mt: 3 }}
				// disabled={isLoading}
			>
				Create Money Receipt
			</Button>
		</Box>
	);
};

export default EditMoneyReceipt;
